module.exports = __webpack_public_path__ + "img/J5.7861b84b.webp";